<script lang="ts" setup>
import Icon from "../Icon/Icon.vue";

const model = defineModel<boolean>({ required: true });

withDefaults(
  defineProps<{
    id?: string;
    disabled?: boolean;
    size?: 16 | 20;
    value?: string;
    describedBy?: string;
  }>(),
  {
    size: 20,
  },
);
</script>

<template>
  <div
    class="checkbox"
    :data-checked="model"
    :data-disabled="disabled"
    :data-size="size"
  >
    <input
      :id="id"
      class="checkbox--input"
      type="checkbox"
      :value="value"
      :checked="model"
      :disabled="disabled"
      :aria-describedby="describedBy"
      @change="model = ($event.target as HTMLInputElement).checked"
    />
    <Icon
      icon="check"
      class="checkbox--input-icon"
    />
  </div>
</template>

<style scoped>
@import "Checkbox.css";
</style>
